"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = ({
  size = 12,
  width = size,
  height = size,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("path", {
  d: "M11.7569 8.18121C12.1243 8.51191 12.1243 9.08808 11.7569 9.41878C11.4403 9.70372 10.9597 9.70372 10.6431 9.41878L8.88888 7.84L8.88888 15.1111C8.88888 15.602 8.49091 16 7.99999 16C7.50907 16 7.1111 15.602 7.1111 15.1111L7.1111 7.84L5.35689 9.41878C5.04029 9.70372 4.55968 9.70372 4.24308 9.41878C3.87564 9.08808 3.87564 8.51192 4.24308 8.18122L7.33102 5.40207C7.71133 5.05979 8.28865 5.05979 8.66895 5.40207L11.7569 8.18121ZM1.77776 1.6L0.800339 1.6C0.358316 1.6 -0.000200272 1.2868 0.000103951 0.844782C0.000407219 0.403034 0.358782 0 0.800529 0L15.2 0C15.6418 0 16 0.215518 16 0.657289C16 1.09925 15.6417 1.6 15.1997 1.6H14.2222L1.77776 1.6Z"
}));

exports.default = _default;